import React, { useEffect } from "react";
import FlipCardSlider from "../../components/Slider/FlipCardSlider";
import ArticleContainer from "../../components/Article/ArticleContainer";
import ArticleHero from "../../components/Hero/ArticleHero";

const relatedBlogs = [
  {
    contentType: "BLOG",
    title: "Complimenting Fleet Modernization with Road Safety",
    description:
      "Shoora is leading the charge in transforming fleet operations by enhancing safety and operational efficiency through the Voluntary Vehicle-Fleet Modernization Programme (VVMP).",
    link: "/insights/blog/complimenting-fleet-modernization-with-road-safety",
    linkText: "Read article",
    thumbnail:
      "https://images.pexels.com/photos/11389692/pexels-photo-11389692.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
    readTime: 10,
  },
  {
    contentType: "BLOG",
    title: "Envisioning the Future of Mobility with Shoora",
    description:
      "Shoora offers comprehensive fleet management solutions that track vehicle locations, monitor driver performance, optimise routes, and reduce fuel consumption.",
    thumbnail: "/images/thumbnails/14.jpeg",
    link: "/insights/blog/envisioning-the-future-of-mobility-with-shoora",
    readTime: 10,
  },
  {
    contentType: "BLOG",
    title: "Leverage AIS-140’s Mandate for Telematics Devices",
    description:
      "Shoora, a leader in advanced video telematics solutions , is committed to harnessing the potential of this mandate to create safer roads and smarter transportation systems.",
    thumbnail: "https://www.easyembedded.net/images/ais2.jpg",
    link: "/insights/blog/how-shoora-aims-to-leverage-ais-140s-mandate-for-telematics-devices-in-public-transportation-and-commercial-vehicles",
    readTime: 10,
  },

  {
    contentType: "BLOG",
    title: "Truck Driver Safety Tips: A Guide to Protecting Lives on the Road",
    description:
      "Shoora, through its advanced video telematics solutions, is helping to curb these numbers and protect lives.",
    thumbnail:
      "https://images.pexels.com/photos/27946843/pexels-photo-27946843/free-photo-of-truck-rearview-mirror.jpeg?auto=compress&cs=tinysrgb&w=600",
    link: "/insights/blog/truck-driver-safety-tips-a-guide-to-protecting-lives-on-the-road",
    readTime: 10,
  },
  {
    contentType: "CUSTOMER STORY",
    title: "Shoora Life Savers Helped BLR Logistics Avert Over 7,500 Accidents",
    description:
      "Shoora is not just a service provider for BLR Logistics; they are a trusted safety partner.",
    thumbnail:
      "https://images.jdmagicbox.com/v2/comp/mumbai/26/022p1955726/catalogue/blr-logistics-india-ltd-goregaon-east-mumbai-transporters-for-all-india-3m98o5wutw.jpg",
    link: "/insights/customer-stories/how-shoora-life-savers-helped-blr-logistics-avert-over-7500-accidents",
    readTime: 10,
  },

  {
    contentType: "CUSTOMER STORY",
    title: "Kapoor Diesels Truck Achieves 1,60,200 Accident-Free Kilometres",
    description:
      "The integrated suite of technologies offered Kapoor Diesel enhanced safety, better fleet management, and measurable cost savings.",
    thumbnail: "/images/thumbnails/15.jpeg",
    link: "/insights/customer-stories/kapoor-diesel-fleet-achieves-60200-accident-free-kilometres-with-shooras-cutting-edge-video-telematics-solutions",
    readTime: 10,
  },
];
const data = {
  contentType: "Article",
  title: "CabIn Vision™ DSM Cameras – Redefining Fleet Safety and Performance",
  description:
    "CabIn Vision™ DSM Cameras deliver next-generation safety and efficiency with real-time driver behavior monitoring. Equipped with 2-channel and 3-channel systems",
  author: "Shoora",
  createdOn: "2nd Nov, 2024",
  imgsrc: "/images/thumbnails/3.jpeg",
  readTime: 10,
  content: ` 
            <h2>Advanced Monitoring for Safer Roads</h2>
     <p>
     CabIn Vision™ DSM Cameras deliver next-generation safety and efficiency with real-time driver behavior monitoring. Equipped with 2-channel and 3-channel systems, our AI-driven dashcams empower fleet operators to take proactive steps toward safer, more reliable operations.
     </p>

    <h2>Key Features and Advantages</h2>
    <h4>1. Proactive Safety Intervention</h4>
    <p>CabIn Vision™ detects and addresses risks before they escalate, helping prevent accidents:</p>
    <ul>
      <li>Monitors fatigue, distractions (like phone use or eating), and unsafe behaviors such as smoking or seatbelt violations.</li>
      <li>Sends real-time alerts, enabling immediate corrective action to protect drivers and cargo.</li>
      <li>Cultivates a culture of safety, fostering accountability and responsible driving.</li>

    </ul>

    <h4>2. High-Definition Visibility and On-Demand Evidence</h4>
    <p>Our dashcams deliver crystal-clear insights with up to 2K (1440p) resolution:</p>
    <ul>
      <li>Instantly access video footage for incident reconstruction and compliance</li>
      <li>Reduce liability, resolve false claims, and protect drivers efficiently.</li>
      <li>Simplify investigations with precise event data to save time and resources.</li>
    </ul>

    <h4>3. Seamless Integration and Rapid Deployment</h4>
    <p>CabIn Vision™ is designed for effortless implementation and superior connectivity:</p>
    <ul>
      <li>Plug-and-play setup ensures your system is operational within minutes.</li>
      <li>Integrated with Shoora’s 24/7 Control Room for enhanced fleet oversight.</li>
      <li>Two-way communication keeps drivers supported during alerts or emergencies, minimizing risks and delays.</li>
    </ul>

    <h2>Enhancing Fleet Safety with DSM Technology</h2>
    <p>Our Driver State Monitoring (DSM) system leverages AI to track and improve driver behavior:</p>
    <ul>
      <li>Identifies drowsiness, fatigue, and focus issues in real-time.</li>
      <li>Detects distractions like smartphone use or eating to ensure safer journeys.</li>
      <li>Cloud-based video recording and analytics integrate seamlessly with telematics systems for a holistic fleet solution.</li>
    </ul>
    <p>By addressing unsafe practices and providing real-time feedback, CabIn Vision™ ensures every mile is safer and more secure.</p>

    <h2>Why Choose CabIn Vision™?</h2>
    <ul>
      <li><strong>Intelligent Risk Mitigation:</strong> Detects and resolves potential dangers instantly.</li>
      <li><strong>Real-Time Alerts:</strong> Instant notifications for critical driver behaviors.</li>
      <li><strong>Seamless Connectivity:</strong> Cloud-enabled access for monitoring and analysis.</li>
      <li><strong>Driver Engagement:</strong> Builds safer habits with ongoing coaching and support.</li>
    </ul>
    <p>Empower your fleet with CabIn Vision™ DSM Cameras—setting a new standard for safety, accountability, and performance. At Shoora, safety isn’t just a priority; it’s the foundation of everything we do.</p>`,
};
const CabinVisionDSM = () => {
  useEffect(()=> {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  },[]);
  return (
    <>
      <ArticleHero
        contentType={data?.contentType}
        title={data?.title}
        createdOn={data?.createdOn}
        imgsrc="/images/about/bg8.webp"
      />
      <div className="bg-dark">
        <div className="container">
          <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <a href="#">Home</a>
              </li>
              <li class="breadcrumb-item">
                <a href="#">Insights</a>
              </li>
              <li class="breadcrumb-item">
                <a href="#" className="text-capitalize">
                  {data?.contentType}s
                </a>
              </li>
              <li class="breadcrumb-item active" aria-current="page">
                {data?.title}
              </li>
            </ol>
          </nav>
        </div>
      </div>

      <ArticleContainer data={data} />
      <hr
        className="bordInstantly access video footage for incident reconstruction and complianceer-3"
        style={{ borderColor: "var(--accent-color)" }}
      />
      <div
                className="stories-section section my-5"
                style={{ maxWidth: "100%" }}
            >
                <div className="container">
                    
                <FlipCardSlider data={relatedBlogs} title={"You may also like"}/>
                </div>
            </div>
    </>
  );
};

export default CabinVisionDSM;
